import React, { Component } from 'react';

import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Radio from '@material-ui/core/Radio';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import {IMaskInput} from 'react-imask';
import IMask from 'imask';

import { FormattedMessage, intlShape } from 'react-intl';

let baseProps = {
  variant: "outlined",
  margin: "dense",
  fullWidth: true
}

let defaultProps = {
  InputLabelProps: {
    shrink: true
  },
  ...baseProps};

let templates = {
  'personal': (values, onChange, intl) => {
    const { firstname, lastname, dob, sex } = values || {};
    const c = (v) => (e) => onChange(Object.assign({}, values, {[v]: e.target.value}));
    return (<div className="metadataField">
      <label>
        <FormattedMessage
          id='metadata.personal'
          defaultMessage='Personalien'
        />
      </label>
      <div>
        <div style={{display:'grid', gridGap: 'inherit', gridTemplateColumns: '1fr 1fr'}}>
        <TextField {...defaultProps} label={intl.formatMessage({id: 'metadata.personal.firstname', defaultMessage: "Vorname"})}  onInput={c('firstname')} defaultValue={firstname} />
        <TextField {...defaultProps} label={intl.formatMessage({id: 'metadata.personal.lastname', defaultMessage: "Name"})}  onInput={c('lastname')} defaultValue={lastname} />
        </div>
        <div style={{display:'grid', gridGap: 'inherit', gridTemplateColumns: '1fr 1fr'}}>
        <TextField {...defaultProps} label={intl.formatMessage({id: 'metadata.personal.dob', defaultMessage: "Geburtsdatum"})}  placeholder={intl.formatMessage({id: 'metadata.personal.dob.placeholder', defaultMessage: 'TT.MM.JJJJ'})} onInput={c('dob')} defaultValue={dob} />
        <FormControl {...baseProps}>
          <InputLabel id="nc-sex">
            <FormattedMessage
              id='metadata.personal.sex'
              defaultMessage='Geschlecht'
            />
          </InputLabel>
          <Select
            {...baseProps}
            labelId="nc-sex"
            style={{marginTop: 0}}
            label={intl.formatMessage({id: 'metadata.personal.sex', defaultMessage: 'Geschlecht'})}
            value={sex}
            defaultValue=""
            native
            onChange={c('sex')}
          >
            <option value=""></option>
            <option value="female">
              {intl.formatMessage({id: 'metadata.personal.sex.female', defaultMessage: 'weiblich'})}
            </option>
            <option value="male">
              {intl.formatMessage({id: 'metadata.personal.sex.male', defaultMessage: 'männlich'})}
            </option>
          </Select>
        </FormControl>
        </div>
      </div>
    </div>)
  },
  'communication': (values, onChange, intl) => {
    const { tel } = values || {};
    const c = (v) => (e) => onChange(Object.assign({}, values, {[v]: e.target.value}));
    return (<div className="metadataField">
      <label>
        <FormattedMessage
          id='metadata.communication'
          defaultMessage='Kontakt'
        />
      </label>
      <div>
        <div style={{display: 'grid', gridGap: 'inherit', gridTemplateColumns: '1fr 1fr'}}>
          <TextField
            {...defaultProps}
            label={intl.formatMessage({id: 'metadata.communication.tel', defaultMessage: "Telefon"})}
            placeholder={intl.formatMessage({id: 'metadata.communication.tel.placeholder', defaultMessage: '+41 7X XXX XX XX'})} onInput={c('tel')} defaultValue={tel} />
        </div>
      </div>
    </div>)
  },
  'address': (values, onChange, intl) => {
    const { street, postal, city, country, no } = values || {};
    return (<div className="metadataField">
      <label>
        <FormattedMessage
          id='metadata.address'
          defaultMessage='Adresse'
        />
      </label>
      <div>
        <div style={{display:'grid', gridGap: 'inherit', gridTemplateColumns: '3fr 1fr'}}>
          <TextField {...defaultProps} label={intl.formatMessage({id: 'metadata.address.street', defaultMessage: "Strasse"})} onInput={e => onChange(Object.assign({}, values, {street: e.target.value}))} defaultValue={street} />
          <TextField {...defaultProps} label={intl.formatMessage({id: 'metadata.address.no', defaultMessage: "Nr."})} onInput={e => onChange(Object.assign({}, values, {no: e.target.value}))} defaultValue={no} />
        </div>
        <div style={{display:'grid', gridGap: 'inherit', marginTop: '10px', gridTemplateColumns: '1fr 1fr 3fr'}}>
          <TextField {...defaultProps} label={intl.formatMessage({id: 'metadata.address.country', defaultMessage: "Land"})} onInput={e => onChange(Object.assign({}, values, {country: e.target.value}))} defaultValue={country||"CH"} />
          <TextField {...defaultProps} label={intl.formatMessage({id: 'metadata.address.postal', defaultMessage: "PLZ"})} onInput={e => onChange(Object.assign({}, values, {postal: e.target.value}))} defaultValue={postal} />
          <TextField {...defaultProps} label={intl.formatMessage({id: 'metadata.address.city', defaultMessage: "Stadt"})} onInput={e => onChange(Object.assign({}, values, {city: e.target.value}))} defaultValue={city} />
        </div>
      </div>
    </div>)
  },
  'insurance': (values, onChange, intl) => {
    const { insurance, insuranceCardNo } = values || {};
    return (<div className="metadataField">
      <label>
        <FormattedMessage
          id='metadata.insurance'
          defaultMessage='Versicherung'
        />
      </label>
      <div>
        <FormControl {...baseProps}>
          <InputLabel id="nc-insurance">
            <FormattedMessage
              id='metadata.insurance.insurance'
              defaultMessage='Krankenkasse'
            />
          </InputLabel>
          <Select
            {...baseProps}
            style={{marginTop: 0}}
            labelId="nc-insurance"
            label={intl.formatMessage({id: 'metadata.insurance.insurance', defaultMessage: 'Krankenkasse'})}
            value={insurance}
            defaultValue=""
            native
            onChange={e => onChange(Object.assign({}, values, {insurance: e.target.value}))}
          >
            <option value=""></option><option value="Agrisano Krankenkasse AG">Agrisano Krankenkasse AG</option><option value="AMB Assurances">AMB Assurances</option><option value="Amt für Gesundheit">Amt für Gesundheit</option><option value="Aquilana Versicherungen">Aquilana Versicherungen</option><option value="Arcosana">Arcosana</option><option value="Assura-Basis SA">Assura-Basis SA</option><option value="Atupri Gesundheitsversicherung">Atupri Gesundheitsversicherung</option><option value="Avenir Krankenversicherung AG">Avenir Krankenversicherung AG</option><option value="Caisse-maladie Vallée d'Entremont">Caisse-maladie Vallée d'Entremont</option><option value="Cassa da malsauns Lumneziana">Cassa da malsauns Lumneziana</option><option value="Compact Grundversicherungen AG">Compact Grundversicherungen AG</option><option value="CONCORDIA Krankenversicherung inkl. FL">CONCORDIA Krankenversicherung inkl. FL</option><option value="CSS Versicherung">CSS Versicherung</option><option value="Easy Sana Krankenversicherung AG">Easy Sana Krankenversicherung AG</option><option value="EGK-Gesundheitskasse">EGK-Gesundheitskasse</option><option value="FKB - Die liechtensteinische Gesundheitskasse">FKB - Die liechtensteinische Gesundheitskasse</option><option value="GALENOS">GALENOS</option><option value="Gemeinsame Einrichtung KVG">Gemeinsame Einrichtung KVG</option><option value="Glarner Krankenversicherung">Glarner Krankenversicherung</option><option value="Helsana Versicherungen AG (inkl. Avanex)">Helsana Versicherungen AG (inkl. Avanex)</option><option value="HPR SA">HPR SA</option><option value="Intras Kranken-Versicherung AG">Intras Kranken-Versicherung AG</option><option value="KLuG Krankenversicherung">KLuG Krankenversicherung</option><option value="kmu-Krankenversicherung">kmu-Krankenversicherung</option><option value="Kolping Krankenkasse">Kolping Krankenkasse</option><option value="KPT/CPT">KPT/CPT</option><option value="Kranken- und Unfallkasse Einsiedeln">Kranken- und Unfallkasse Einsiedeln</option><option value="Krankenkasse Birchmeier">Krankenkasse Birchmeier</option><option value="Krankenkasse Institut Ingenbohl">Krankenkasse Institut Ingenbohl</option><option value="Krankenkasse Luzerner Hinterland">Krankenkasse Luzerner Hinterland</option><option value="Krankenkasse Simplon">Krankenkasse Simplon</option><option value="Krankenkasse SLKK">Krankenkasse SLKK</option><option value="Krankenkasse Steffisburg">Krankenkasse Steffisburg</option><option value="Krankenkasse Stoffel Mels">Krankenkasse Stoffel Mels</option><option value="Krankenkasse Turbenthal">Krankenkasse Turbenthal</option><option value="Krankenkasse Visperterminen">Krankenkasse Visperterminen</option><option value="Krankenkasse Wädenswil">Krankenkasse Wädenswil</option><option value="Krankenversicherung Flaachtal">Krankenversicherung Flaachtal</option><option value="Moove Sympany">Moove Sympany</option><option value="Mutuel Krankenversicherung AG">Mutuel Krankenversicherung AG</option><option value="ÖKK Kranken- und Unfallversicherungen AG [KVG]">ÖKK Kranken- und Unfallversicherungen AG [KVG]</option><option value="Philos Krankenversicherung AG">Philos Krankenversicherung AG</option><option value="Progrès Versicherungen AG (inkl. Sansan)">Progrès Versicherungen AG (inkl. Sansan)</option><option value="PROVITA Gesundheitsversicherung AG">PROVITA Gesundheitsversicherung AG</option><option value="rhenusana">rhenusana</option><option value="sana24">sana24</option><option value="Sanagate AG">Sanagate AG</option><option value="Sanavals">Sanavals</option><option value="Sanitas Krankenversicherung">Sanitas Krankenversicherung</option><option value="Société d'assurance dommages FRV SA">Société d'assurance dommages FRV SA</option><option value="sodalis gesundheitsgruppe">sodalis gesundheitsgruppe</option><option value="Sumiswalder">Sumiswalder</option><option value="SUPRA-1846 SA">SUPRA-1846 SA</option><option value="SVK - Verband">SVK - Verband</option><option value="SWICA Gesundheitsorganisation inkl. FL">SWICA Gesundheitsorganisation inkl. FL</option><option value="Visana Services AG">Visana Services AG</option><option value="vita surselva">vita surselva</option><option value="vivacare&nbsp;">vivacare&nbsp;</option><option value="Vivao Sympany">Vivao Sympany</option>
          </Select>
        </FormControl>
        <TextField {...defaultProps} style={{marginTop: '10px'}}
          placeholder="807XXXXXXXXXXXXXXXXX"
          label={intl.formatMessage({id: 'metadata.insurance.insuranceCardNo', defaultMessage: "Karten-Nr."})}
          onInput={e => onChange(Object.assign({}, values, {insuranceCardNo: e.target.value}))}
          defaultValue={insuranceCardNo} />
      </div>
    </div>)
  }
}

class MetadataField extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  render() {
    const { values, field, config, onChange } = this.props;

    if (field.type in templates) {
      return templates[field.type](values, onChange, this.context.intl);
    }

    return <div className="metadataField"></div>;
  }
};

export default MetadataField;


// WEBPACK FOOTER //
// ./src/shared/MetadataField.js